// NOTICE!! THIS IS REQUIRED TO MAKE YOUR NETO SHOPPING CART WORK
// DO NOT REMOVE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING

(function($) {
	$.extend({
		initPageFuncs: function() {
			// Ajax Wish List
			$.addToWishList({
				'class': 'wishlist_toggle',
				'textclass': 'wishlist_text',
				'htmlon': '<i class="fa fa-heart"></i>',
				'htmloff': '<i class="fa fa-heart-o"></i>',
				'tooltip_css': 'whltooltips'
			});
			// Ajax Add To Cart
			$.addToCartInit({
				'cart_id' :  'cartcontents',
				'target_id': 'cartcontentsheader',
				'image_rel': 'itmimg'
			});

			$(".disp_ajax_templ").unbind();
			$(".disp_ajax_templ").change(function() {
				var sku = $(this).val();
				var rel = $(this).attr('rel');
				$.load_ajax_template(rel, {'sku':sku, 'showloading':true, 'procdata':'n'}, {onLoad: function (){$.initPageFuncs();}});
			});
			// This renders the instant search results - edit design of ajax results here
			$.initSearchField({
				'result_header'		: '<ul class="nav nav-list">',
				'result_body'		: '<li><a href="javascript:void(0);" search-keyword="##keyword##"><img border="0" src="##thumb##" width="36" height="36"/><span class="title">##model##</span></a></li>',
				'result_footer'		: '</ul>',
				'category_header'	: '<ul class="nav nav-list">',
				'category_body'		: '<li><a href="##url##"><span class="thumb"><img border="0" src="##thumb##" width="36" height="36"/></span><span class="title">##fullname##</span> <span class="label label-default">##typename##</span></a></li>',
				'category_footer'	: '</ul>'
			});
		},

// For child product multi-add to cart function
		checkValidQty: function() {
			var found = 0;
			$("#multiitemadd :input").each(function() {
				if ($(this).attr('id').match(/^qty/)) {
					if ($(this).val() > 0) {
						found = 1;
					}
				}
			});
			if (found == 0) {
				$.fancybox("Please specify a quantity before adding to cart");
				return false;
			}
			return true;
		},

		modQtyByMulti: function(obj,act) {
			var mul = 1;
			var maxm;
			var minm = 0;
			var objid = obj.replace(/^qty/,'');
			if ($('#qty'+objid).length > 0) {
				if ($('#multiplier_qty'+objid).length > 0) {
					mul = $('#multiplier_qty'+objid).val();
				}
				if ($('#min_qty'+objid).length > 0) {
					minm = $('#min_qty'+objid).val();
				}
				if ($('#max_qty'+objid).length > 0) {
					maxm = $('#max_qty'+objid).val();
				}

				var cur = $('#'+obj).val();
				if (isNaN(cur)) {
					cur = 0;
				}

				if (act == 'add') {
					cur = parseInt(cur) + parseInt(mul);
					if (!isNaN(maxm) && cur > maxm) {
						cur = maxm;
					}
				}
				else if (act == 'subtract') {
					cur = parseInt(cur) - parseInt(mul);
					if (cur < minm) {
						cur = minm;
					}
				}

				$('#qty'+objid).val(cur);
			}
		}
	});
})(jQuery);

var customHook = {
	addToCart: function() {
		$('.search-overlay').addClass('modal-backdrop fade in');
		
	},
	init: function() {
		nAddItemCallbacks.push(customHook.addToCart);
	}
}
customHook.init();

// $(document).ready(function() {
//     var myLazyLoad = new LazyLoad({
//         elements_selector: '.lazy'
//     });
//
// });

$(document).ready(function() {
	// Jquery Ui Date Picker
	$(".datepicker").datepicker({ dateFormat: "dd/mm/yy" });
	$.initPageFuncs();

	// Carousel
	$('.carousel').carousel();

});

$(".btn-loads").click(function(){
	$(this).button("loading");
	var pendingbutton=this;
	setTimeout(function(){
		$(pendingbutton).button("reset");
	},3000);
});

// Fancybox
$(document).ready(function() {
	if (typeof fancybox === "function") {
		$(".fancybox").fancybox();
	}
});

// Tooltip
$('.tipsy').tooltip({trigger:'hover',placement:'bottom'});

// Who needs AddThis?
function windowPopup(url, width, height) {
	// Calculate the position of the popup so
	// it’s centered on the screen.
	var left = (screen.width / 2) - (width / 2),
		top = (screen.height / 2) - (height / 2);
	window.open(url,"","menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
}
$(".js-social-share").on("click", function(e) {
	e.preventDefault();
	windowPopup($(this).attr("href"), 500, 300);
});

$('.nToggleMenu').click(function(){
	$(this).toggleClass('open');
	var toggleTarget = $(this).attr('data-target');
	$(toggleTarget).slideToggle();
	$('.mobile-menu-overlay').toggleClass('modal-backdrop fade in');
});

$('.mobile-menu-overlay').click(function() {
	$('.nToggleMenu').click();
});

$('.nav-full').hover(
	function() {
		$('.main-menu-overlay').addClass('modal-backdrop');
	},
	function() {
		$('.main-menu-overlay').removeClass('modal-backdrop');	
	}
);
	
$(window).load(function() {
	$('#homepageCarousel .item').css({ 'display' : 'block' });
	if ($('.single-item-fade, .slider-for, .nCustom-slick-responsive').length > 0) {
		// Home Slick
		$('.single-item-fade').slick({
			dots: true,
			arrows:true,
		    infinite: true,
		    fade: true,
		    cssEase: 'linear',
			autoplay: true,
		    autoplaySpeed: 5000
		});
		// Product Page Alt Images
		
		// Change the main image whenever a thumbnail button is activated
		  $('.slider-nav').on('init', function(e, slider) {
			$(slider.$slides.find('.prod-thumb-img')).each(function(index) {
			  $(this).on('click', function() {
				// Move aria-current="true" to this button
				$(slider.$slides.find('.prod-thumb-img').removeAttr('aria-current'));
				$(this).attr('aria-current', true);
		
				// Change the main image to match this thumbnail button
				var index = $(this).closest('.slick-slide').data('slick-index');
				$('.slider-for').slick('slickGoTo', index);
			  });
			});
		  });
	$('.slider-for').not('.slick-initialized').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  dots: false,
	  // asNavFor: '.slider-nav',
	  lazyLoad: 'ondemand'
	});
	$('.slider-nav').not('.slick-initialized').slick({
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  // asNavFor: '.slider-for',
	  dots: true,
	  arrows: false,
	  centerMode: false,
	  autoplay: false,
	  lazyLoad: 'ondemand'
	});
	
	// Update the thumbnail slider when the user changes the main slider directly.
	$('.slider-for').on('beforeChange', function(e, slider, currentSlide, nextSlide) {
	  // Remove aria-current from the last selected thumbnail image button
	  $('.slider-nav .prod-thumb-img[aria-current="true"]').removeAttr('aria-current');
	  
	  // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
	  $('.slider-nav').slick('slickGoTo', nextSlide);
	
	  // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
	  $('.slider-nav .prod-thumb-img:eq(' + nextSlide + ')').attr('aria-current', true);
	}); 
	
		// Thumbnails to slick
		$('.nCustom-slick-responsive').slick({
		  dots: true,
		  arrows: false,
		  infinite: true,
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 3,
		        slidesToScroll: 1,
		        infinite: true,
		        dots: true
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 2,
		        slidesToScroll: 1
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		  ]
		});
	}
});

// Show all Slick Items
setTimeout(function() {
    $('.nCustom-slick-all').hide().css('visibility','visible').fadeIn('slow');
}, 200);
// Activates Mobile Menu
$('#menu-toggle').click(function(){
	$(this).toggleClass('toggled');
	$('body').toggleClass('nav-open');
});
// Alt Image Hover Effect
$('.wrapper-thumbnail .thumbnail-image')
	.mouseover(imageSwap)
	.mouseout(imageSwap);
function imageSwap(){
	var myImage = $(this).find('img.product-image');
	newSRC = $(myImage).attr('data-altimg');
	if(newSRC){
		currentSRC = $(myImage).attr('src');
		$(myImage).attr('src',newSRC);
		$(myImage).attr('data-altimg',currentSRC);
	}
}
$('.btn-search').click(function() {
	$('.wrapper-search-popout').toggle();
	$('#name_search').select();
	// $('.search-overlay').toggle();
	$('.search-overlay').toggleClass('modal-backdrop fade in');
});
$('.search-overlay').click(function() {
    $('.wrapper-search-popout').hide();
    // $(this).hide();
	$('.search-overlay').removeClass('modal-backdrop fade in');
});
$('.wrapper-search-popout > .search-overlay').click(function() {
	$('.wrapper-search-popout').hide();
});

$('.nav-full a').click(function() {
	$('.search-overlay').toggleClass('modal-backdrop fade in');
});

$('.npopup').on('click', function() {
	$('.search-overlay').removeClass('modal-backdrop fade in');
});

// Sidebar Accordions
$('.panel-heading.accordion-toggle').click(function(){
    var caret = $(this).find('i');
    $(this).parent().find('ul').slideToggle();
    if(caret.hasClass('fa-minus')){
        caret.removeClass('fa-minus').addClass('fa-plus');
    }else{
        caret.removeClass('fa-plus').addClass('fa-minus');
    }
});

// Collapse Fitlers
$('.filter-title').click(function(){
 var filtercode = $(this).attr('data-filtercode')
   $('.filter[data-filtercode="'+filtercode+'"]').slideToggle();
     if ($("i", this).hasClass("fa-caret-down")) {
       $("i", this).removeClass('fa-caret-down').addClass('fa-caret-up');
     }
     else {
       $("i", this).removeClass('fa-caret-up').addClass('fa-caret-down');
   	}
});
$('.filter-title[data-filtercode=price]').click(function(){
 $(this).next('.price-range').toggle();
   if ($("i", this).hasClass("fa-caret-down")) {
     $("i", this).removeClass('fa-caret-down').addClass('fa-caret-up');
   }
   else {
     $("i", this).removeClass('fa-caret-up').addClass('fa-caret-down');
   }
});
$('.filter-title[data-filtercode=price-lg]').click(function(){
 $(this).next('.price-range-lg').toggle();
 if ($("i", this).hasClass("fa-caret-down")) {
     $("i", this).removeClass('fa-caret-down').addClass('fa-caret-up');
   }
   else {
     $("i", this).removeClass('fa-caret-up').addClass('fa-caret-down');
   }
});

// Mobile Menu
$('.mobile-menu .dropdown-hover > a').click(function() {
	$(this).toggleClass('active');
	$(this).parent().children('.dropdown-menu').toggleClass('open');
	return false;
});

// Commercial Solutions
$('.navbar-nav a').filter(function() {
    return $(this).text() === 'Commercial Solutions';
}).attr('href', '/pages/commercial-solutions');

// Repairs
$('.navbar-nav a').filter(function() {
    return $(this).text() === 'Repairs';
}).attr('href', '/pages/dji-repairs');

$(document).ready(function () {
    if (window.location.href.indexOf('ferntech.co.nz/dji-repairs/') > -1) {
        window.location = 'https://www.ferntech.co.nz/pages/dji-repairs';
    }
});

// Homepage category headings
$('.homepage-category-1').html($('.homepage-categories span:eq(0)').html());
$('.homepage-category-2').html($('.homepage-categories span:eq(1)').html());
$('.homepage-category-4').html($('.homepage-categories span:eq(2)').html());
$('.homepage-category-3').html($('.homepage-categories span:eq(3)').html());

// Product tabs
if ($(window).width() >= 768) {
	$('.nav-tabs li:first-child').addClass('active');
	$('#description').addClass('active');
}
else {
	$('.nav-tabs li').each(function() {
		tab = $(this).find('a').attr('href');
		$(tab).addClass('container').insertAfter($(this));
	});
	$('.nav-tabs li a').click(function() {
    	$(this).parent().toggleClass('active');
        $('.nav-tabs li').not($(this).parent()).removeClass('active');
    	var href = $(this).attr('href');
    	$('.tab-pane').not(href).removeClass('active-mobile');
    	$(href).toggleClass('active-mobile');
	});
    $('.tab-pane').each(function() {
    	if ($(this).height() > 690) {
    		$(this).addClass('tall-pane');
		}
	});
}

$('.after').click(function () {
	$(this).parent().addClass('expanded');
});

// Pages
$(document).ready(function() {
	if (typeof fitVids === "function") {
    	$('#n_content, .productdetails').fitVids();
	}
});

// Cart & Checkout
$('.toggle-delivery').click(function() {
	$(this).toggleClass('active');
	$('.panel-delivery').toggle();
	return false;
});

$('.toggle-discount').click(function() {
    $(this).toggleClass('active');
    $('.panel-discount').toggle();
    return false;
});

// Mobile nav
// function resizeMobileNav() {
// 	var height = $(document).height();
//     $('.wrapper-usp-header.mobile-menu .navbar-collapse').height(height);
// }
// 
// resizeMobileNav();
// 
// $(window).resize(function() {
// 	resizeMobileNav();
// });

// Bold Compare menu items
$(".lv2-li  a[href='https://www.ferntech.co.nz/drones/compare-crafts/']").addClass('bold');

// Sticky nav
var stickyOffset = $('.category-menu').offset().top;
var stickyOffset2 = $('.wrapper-header-nav').offset().top;

$(window).scroll(function() {
  var sticky = $('.category-menu'),
  	  sticky2 = $('.wrapper-header-nav'),
	  body = $('body'),
	  scroll = $(window).scrollTop();
  
  if (scroll >= stickyOffset2) {
	sticky.addClass('nav-sticky');
	sticky2.addClass('nav-sticky');
	body.addClass('nav-is-sticky');
  }
  else {
	sticky.removeClass('nav-sticky');
	sticky2.removeClass('nav-sticky');
	body.removeClass('nav-is-sticky');
  }
});

// Display homepage banners as carousel on mobile
function bannerCarousel() {
	if ($(document).width() < 768) {
		if(!$('#homepage-banners .row').hasClass('slick-initialized')) {
			$('#homepage-banners .row').slick({
				autoplay: true,
				autoplaySpeed: 5000,
				arrows: false,
				dots: false
			});
		}
	}
	else {
		if ($('#homepage-banners .row').hasClass('slick-initialized')) {
			$('#homepage-banners .row').slick('unslick');
		}
	}
}

bannerCarousel();

$(window).resize(function() {
	bannerCarousel();
});

// Sticky product tabs on mobile
$(document).ready(function() {
	
	if ($(document).width() < 768) {
		$('.wrapper-product-content li a').click(function() {
			if ($('.wrapper-product-content li').hasClass('tabs-sticky')) {
				$('html, body').animate({
					scrollTop: $('.wrapper-product-content').offset().top
				}, 500);
			}
			$('.wrapper-product-content li').removeClass('tabs-sticky');
		});
		
	  	$(window).scroll(function() {
		  	if ($('.wrapper-product-content li').hasClass('active')) {
				var wrapperTop = $('.wrapper-product-content').offset().top;
			  	var stickyTab = $('.wrapper-product-content li.active').offset().top;
				var windowTop = $(window).scrollTop();
				
				if (windowTop < wrapperTop) {
					$('.wrapper-product-content li.active').removeClass('tabs-sticky');
				}
				else if (windowTop >= stickyTab) {
					$('.wrapper-product-content li.active').addClass('tabs-sticky');
				}
			}
	  	});
    }
});

// Google My Business reviews
// jQuery(document).ready(function() {
// 	if ($("#google-reviews").length !== 0) {
// 		$('#google-reviews').googlePlaces({
// 			placeId: 'ChIJP8wKp8ZHDW0RKE78q2u69qI',
// 			header: "<h2>WHAT OUR CUSTOMERS ARE SAYING</h2>",
// 			footer: '',
// 			maxRows: 5,
// 			minRating: 4,
// 			textBreakLength: '90',
// 			shortenNames: true,
// 			moreReviewsButtonUrl: 'https://www.google.com/maps/place/DJI+Authorised+Retail+Store+(Ferntech)/@-36.8666022,174.757471,15z/data=!3m1!5s0x6d0d47c6a13b6345:0x2419dca6bc14f837!4m7!3m6!1s0x0:0xa2f6ba6babfc4e28!8m2!3d-36.8666022!4d174.757471!9m1!1b1?hl=en',
// 			moreReviewsButtonLabel: 'See More Reviews',
// 			writeReviewButtonUrl: '',
// 			writeReviewButtonLabel: 'Write New Review',
// 			showProfilePicture: true
// 		});
// 	}
// });

// My Account
$(function() {
	if ($('.n_customer .well').length > 0) {
		//$('.n_customer .well').matchHeight();
	}
});

// Blog - events
$(document).ready(function() {
	if ($('.event-index').length > 0) {
		$('.event-index .wrapper-thumbnail').each(function() {
			// Format location
			var raw_event_location = $(this).find('.event-location-unformatted').text().split('|');
			$(this).find('.event-location span').text(raw_event_location[0]);
			$(this).find('.event-location a').attr('href', raw_event_location[1]);
			
			// Move recent events to recent events
			var event_date = $(this).data('date');
			var event_date_object = new Date(event_date);
			
			var date = new Date();
			var day = date.getDate();
			var month = date.getMonth() + 1;
			var year = date.getFullYear();
			var todays_date = year + '-' + month + '-' + day;
			
			if (date > event_date_object) {
				$(this).appendTo($('#recent-events-holder'));
				$(this).find('h4 span').text('Past');
			}
		});
	}
});

// Upsells
// var upsellOffset = 90;
// var upsellSidebarOffset = $('.sticky-scroller').offset().top;
// var upsellHeight = $('.sticky-scroller').height() + 180;
// 
// $(window).scroll(function() {
//   var stickyImages = $('#_jstl__images_r'),
// 	  body = $('body'),
// 	  scroll = $(window).scrollTop();
//   if (scroll >= upsellOffset && scroll <= upsellHeight && $(document).width() >= 768) {
// 	stickyImages.addClass('images-sticky');
//   }
//   else {
//   	stickyImages.removeClass('images-sticky');
//   }
// });

// Homepage carousels
$(document).ready(function() {
	function homeCarousels() {
		var removeSelected = true;
		
		if ($('#homepage-banner-commercial .row').hasClass('slick-initialized')) {
			$('#homepage-banner-commercial .row').slick('unslick');
			removeSelected = false;
		}
		
		if ($('#homepage-banner-camera .row').hasClass('slick-initialized')) {
			$('#homepage-banner-camera .row').slick('unslick');
		}
		
		$('#homepage-banner-commercial .row').on('init', function(slick) {
			if (removeSelected === true && $('.home-carousel.selected').length > 1) {
				$('#homepage-banner-commercial').removeClass('selected');
			}
		});
			
		if ($(document).width() < 768) {
			$('.home-carousel .row').slick({
				dots: false,
				arrows: true,
				infinite: true,
				cssEase: 'linear',
				autoplay: false
			});
		}
		else {
			$('.home-carousel .row').slick({
				dots: false,
				arrows: true,
				infinite: true,
				cssEase: 'linear',
				autoplay: false,
				slidesToShow: 5,
				slidesToScroll: 1
			});
		}
	}
	
	homeCarousels();
	
	$(window).resize(function() {
		homeCarousels();
	});
	
	$('.home-carousel-toggle a').click(function() {
		$('.home-carousel-toggle a').removeClass('active');
		$(this).addClass('active');
		
		var carousel = $(this).attr('data-toggle');
		$('.home-carousel').removeClass('selected');
		$('#' + carousel).addClass('selected');
		$('.home-carousel .row').slick('refresh');
		
		return false;
	});

});
